import _isArray from "lodash/isArray";
import _isNumber from "lodash/isNumber";
import _isString from "lodash/isString";
// a helper method to convert a node to a
// succinct, pretty, human-readable string
// for error and messages
export default function stringifyNode(node) {
  if (!node) return "".concat(node);
  if (_isString(node)) return node;
  if (_isNumber(node)) return "".concat(node);
  if (_isArray(node)) return "[".concat(node, "]");
  var type = node.type,
      version = node.version;
  return "{ type: '".concat(type, "', version: '").concat(version, "' }");
}